class StickyNavigation extends HTMLElement {
  constructor() {
    super();

    this.activeLink = this.querySelector(".sticky-navigation__link--active");
    this.isScroll = this.activeLink?.hash.includes("#");

    this.addClickListener();
  }

  addClickListener() {
    const links = this.querySelectorAll(".sticky-navigation__link");

    links.forEach(link => link.addEventListener("click", event => this.updateLinks(event, link)));
  }

  updateLinks(event, link) {
    event.preventDefault();

    link.classList.add("sticky-navigation__link--active");

    if (this.activeLink) this.activeLink.classList.remove("sticky-navigation__link--active");
    if (this.activeLink !== link) this.activeLink = link;

    if (this.isScroll) this.scrollToSection(link);
    else window.location.href = this.activeLink.href;
  }

  scrollToSection(link) {
    const section = document.getElementById(link.hash.slice(1));

    console.error(section, link.hash.slice(1))

    if (section) {
      const target = section.getBoundingClientRect().top;
      const offset = document.documentElement.scrollTop;
      const header = document.documentElement.style.getPropertyValue("--mobile-header-height");
      const sticky = this.getBoundingClientRect().height;
      const y = target + offset - sticky - header.replace("px", "");

      requestAnimationFrame(() => window.scrollTo({ top: y, behavior: "smooth" }));
    }
  }
}

customElements.define("sticky-navigation", StickyNavigation);